import React, { useEffect } from 'react';
import { SalesPage } from './components/SalesPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <SalesPage data-id="element-0" />;
}